import React from 'react';
import styled from 'styled-components';

const LoadDIV = styled.div`
	&.ff-chatloader-container {
		display: flex;
		justify-content: center;
		margin-left: ${(props) => props.margin};
		& > .loader-dot {
			width: ${(props) => props.width};
			height: ${(props) => props.height};
			border-radius: 50%;
			background-color: ${(props) => props.dotcolor};
			margin: 0 2px;
			animation: bounce 0.3s infinite alternate;
			&:nth-child(2) {
				animation-delay: 0.1s; /* Delay for the second dot */
			}
			&:nth-child(3) {
				animation-delay: 0.2s; /* Delay for the third dot */
			}
			@keyframes bounce {
				0% {
					transform: translateY(0);
				}
				100% {
					transform: translateY(-10px);
				}
			}
		}
	}
`;
type Props = {
	dotcolor?: string;
	width?: string;
	height?: string;
	margin?: string;
};

const ChatLoader = ({ dotcolor, width, height, margin }: Props) => {
	return (
		<LoadDIV
			className='ff-chatloader-container'
			dotcolor={dotcolor && dotcolor.length ? dotcolor : '#333'}
			width={width && width.length ? width : '7px'}
			height={height && height.length ? height : '7px'}
			margin={margin && margin.length ? margin : '34px'}
		>
			<div className='loader-dot'></div>
			<div className='loader-dot'></div>
			<div className='loader-dot'></div>
		</LoadDIV>
	);
};

export default ChatLoader;
